export const RetailerSegmentTypes = [
  'HOTEL',
  'RESTAURANT',
  'CAFE',
  'RETAIL_CHAIN',
  'TRAFIK',
  'OTHER_RETAILER',
];
